module.exports = __webpack_public_path__ + "img/wristband.02391ae3.png";